export const mode = import.meta.env.MODE;

export const isProd = import.meta.env.PROD;

export const isStaging = window.location.host.includes('staging');

export const isDev = import.meta.env.DEV;
